module.exports = __webpack_public_path__ + "e7a0a8935f00b596a995924668582019.svg";